import React from 'react';

/**
 * ChartShrinkContext — RC-2 pass 2 communication channel.
 * Carries a map of `[data-export-id]` -> `fitMaxHeight` (px) constraints
 * derived by the `PaginatedReportView` during pass 1. Provides `ChartFrame`
 * with its shrunken height constraint without having to thread a prop through
 * every intermediate report layout section.
 */
export const ChartShrinkContext = React.createContext<Record<string, number>>({});
